import { IJSLComponent, IJSLVNode, refresh, JSLRender } from "jsl-render";
import { IJSLGrid, GridComponent, DialogComponent, LoadingComponent, DateFormatter, NumericFormatter } from "jsl-ui";
import { PublicController } from "../../../ajax/PublicController";
import { GridColumn } from "../../../ajax/types/GridColumn";

export class DownloadExcelButtonComponent<T> implements IJSLComponent {

    private g: IJSLGrid<T>;

    private dom: HTMLElement;

    constructor(private grid: GridComponent<T>) {
        grid.getRef().then((g) => {
            this.g = g;
        });
    }

    public render(): IJSLVNode {
        return <div style="display:inline-block">
            <button class="genric-btn primary ml-20 mb-10" href="" click={() => {
                this.generateCheckBoxes(this.grid).then((checkboxes) => {
                    DialogComponent.show({
                        header: "Spalten auswählen",
                        content: checkboxes,
                        footer: <div>
                            {DialogComponent.Button({onClick: () => {
                                this.download();
                            }, content: "download", class: "genric-btn primary" })}
                            {DialogComponent.Cancel()}
                        </div>
                    });
                    refresh();
                });
             }}>als Excel herunterladen</button>
        </div>;
    }

    public onCreate(node: IJSLVNode) {
        this.dom = node.dom;
    }

    public onUpdate(node: IJSLVNode) {
        this.dom = node.dom;
    }


    // public isEqual(node: IJSLComponent): boolean {
    //     return (this as any).__proto__ === (node as any).__proto__;
    // }

    private download() {
        const visibleData = [];
        for (let i = 0, l = this.g.getDataLength(); i < l; i++) {
            visibleData.push(this.g.getDataItem(i));
        }
        const columns = (this.g.getColumns() as unknown as GridColumn[]).filter((c) =>
            (document.getElementById("c_" + c.id) as HTMLInputElement).checked
        );

        for (const c of columns) {
            c.dataType = c.formatter === DateFormatter ? "date" : (c.formatter === NumericFormatter ? "numberic" : "text");
        }

        PublicController.ToExcel({ columns, gridData: visibleData }).then((id) => {
            refresh();
            window.location.href = "/Home/ToExcel?id=" + id;
        });
    }

    private async generateCheckBoxes(grid: GridComponent<T>): Promise<IJSLVNode> {
        const g = await grid.getRef();
        const columns = g.getColumns();
        return <div>
            <div><input change={() => {
                const state = (document.getElementById("c_alle_") as HTMLInputElement).checked;
                const nodes = this.dom.querySelectorAll('input[type="checkbox"]');
                for (let i = 0; i < nodes.length; i++) {
                    (nodes[i] as HTMLInputElement).checked = state;
                }
                return false;
            }} type="checkbox" id="c_alle_" checked="checked" /> <label style="cursor:pointer" for="c_alle_">- Alle -</label></div>
            {columns.map((c) => <div style="padding-left:1rem;">
                <input type="checkbox" id={"c_" + c.id} checked="checked" /> <label style="cursor:pointer" for={"c_" + c.id}>{c.name}</label>
            </div>)}
        </div>;
    }

}
